import { Box } from "@mui/material";
import { BREAK_ } from "constants";
import React from "react";
import styled from "styled-components";
import { Icon } from "assets/Icons_";
import { useGet } from "state/jotai";
import { boostrap } from "state/store.fullEido";
import { F_HOMEPAGE } from "api/full_eido_api";
import { useTranslation } from "react-i18next";
import { _bootstrap } from "state/store.bootstrap";
import { useFetch } from "hooks/fetch/useFetch";

const MainContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 40px 24px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 20px;
  background: ${({ }) => `${f_clr?.secondaryColor}`};
  color:${({ }) => `${f_clr?.secondaryText}`};
  ${BREAK_.md_dn} {
    border-radius: 0px;
    padding: 16px;
  }
`;

const InnerBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const HeadingBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 12px;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ f_clr }) => f_clr.secondaryText };
`;

const GridWrapper = styled.div`
  display: flex;
  align-self: stretch;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 330px;

  ${BREAK_.md_dn} {
    gap: 24px;
  }
`;

const LeftGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-width: 280px;
`;

const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 200px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 16px;
`;

const FacilityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const GroupsDetails = ({ UnitDetails: UD }) => {
  const pid = useGet(_bootstrap).projectids?.[0] || null;
  const {
    i18n: { language }
  } = useTranslation();
  const frontpageData = useFetch({ url: F_HOMEPAGE(pid, language) }).D;
  const eidoData = useGet(boostrap);

  const groupDetailsByGroupName = (details = []) => {
    return details.reduce((acc, item) => {
      const group = item.GroupName || "Andet";
      if (!acc[group]) acc[group] = [];
      acc[group].push(item);
      return acc;
    }, {});
  };

  const groupedDetails = groupDetailsByGroupName(UD?.Details);

  // Get label for 'Faciliteter' in current language
  const facilityGroupLabel = eidoData?.labelPropertiesWebsite?.find(
    (btn) => btn.UILabelProperty === "Faciliteter"
  )?.Label;

  // Match group key based on label
  const facilityGroup = Object.keys(groupedDetails).find(
    (key) =>
      key === facilityGroupLabel ||
      key.toLowerCase().includes("facilit") // fallback match
  );

  const groups = [...new Set(UD?.Details?.map((ud) => ud.GroupName))];

  return (
    <MainContainer>
      <InnerBox>
        <HeadingBox>
          <div className="h3">{UD?.Headline}</div>
          <div
            className="h4"
            style={{
              display: "flex",
              padding: "8px 16px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "20px",
              background: f_clr?.primaryText,
              color: frontpageData?.PropertySlider?.Properties?.[0]
                ?.NoOfVacantUnits
                ? "#1C6347"
                : "#F05030"
            }}
          >
            {
              frontpageData?.PropertySlider?.Properties?.[0]?.NoOfVacantUnits
            }{" "}
            {
              eidoData?.labelPropertiesWebsite?.find(
                (btn) => btn.UILabelProperty === "Ledigeboliger"
              )?.Label
            }
          </div>
        </HeadingBox>

        <Divider f_clr={f_clr} />

        <GridWrapper>
          <LeftGrid>
            {groups.map(
              (group) =>
                groupedDetails[group] &&
                group !== facilityGroup && (
                  <Box key={group}>
                    <div className="h4" style={{ marginBottom: "8px" }}>
                      {group}
                    </div>
                    {groupedDetails[group].map((item) => (
                      <Row className="paragraph1-light" key={item.PropertyID}>
                        <span>{item.Label}</span>
                        <span>{item.Value}</span>
                      </Row>
                    ))}
                  </Box>
                )
            )}
          </LeftGrid>

          <RightBox>
            {facilityGroup && groupedDetails[facilityGroup] && (
              <>
                <Box className="h4">{facilityGroup}</Box>
                {groupedDetails[facilityGroup].map((item) => (
                  <FacilityItem
                    className="paragraph1-light"
                    key={item.PropertyID}
                  >
                    <Icon
                      icon={item.Icon}
                      isFaIcon={false}
                      color={f_clr.secondaryText}
                      size={20}
                    />
                    {item.Label}
                  </FacilityItem>
                ))}
              </>
            )}
          </RightBox>
        </GridWrapper>
      </InnerBox>
    </MainContainer>
  );
};

export default GroupsDetails;
